<template>
  <div class="login-container">
    <!-- 桌面端：居中卡片 -->
    <div class="login-card desktop-only">
      <div class="brand">
        <div class="brand-title">中州气联</div>
        <div class="brand-sub">数据管理平台</div>
      </div>
      <div class="form-title">用户登录</div>
      <el-form
        :model="form"
        label-width="auto"
        label-position="top"
        ref="formName"
        class="login-form"
      >
        <el-form-item prop="account">
          <el-input
            placeholder="请输入登录账号"
            v-model="form.account"
            size="large"
            clearable
			@keyup.enter.native="login"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            placeholder="请输入登录密码"
            v-model="form.password"
            size="large"
            show-password
			@keyup.enter.native="login"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="large"
            @click="login"
            class="login-btn"
          >确定</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 移动端：顶部品牌区 + 下方表单（原有结构） -->
    <div class="left-banner mobile-only">
      <div class="brand-wrapper">
        <div class="brand-title">中州气联</div>
        <div class="brand-sub">数据管理平台</div>
      </div>
      <div class="brand-image">
        <img src="/static/loginbg.png" alt="" />
      </div>
    </div>
    <div class="right-form mobile-only">
      <div class="form-wrapper">
        <div class="form-title">用户登录</div>
        <el-form
          :model="form"
          label-width="auto"
          label-position="top"
          ref="formNameMobile"
          class="login-form"
        >
          <el-form-item prop="account">
            <el-input
              placeholder="请输入登录账号"
              v-model="form.account"
              size="large"
              clearable
			  @keyup.enter.native="login"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              placeholder="请输入登录密码"
              v-model="form.password"
              size="large"
              show-password
			  @keyup.enter.native="login"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="large"
              @click="login"
              class="login-btn"
            >确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { pub } from '/common/event';

export default {
  data: () => ({ form: {}, submitting: false }),
  beforeCreate() {
    this.$store.commit('config/setLeftBar', false);
    this.$store.commit('config/setTopBar', false);
  },
  mounted() {
    const token = this.$route.query.token;
    if (token) this.autoLogin(token);
  },
  methods: {
    async autoLogin(token) {
      try {
        const ret = await this.$r.post(`login/login/refreshTokenLogin`, { token });
        if (ret && ret.success) {
          this.$store.commit('config/setLeftBar', true);
          const userData = ret.data.user;
          localStorage.setItem('user', JSON.stringify(userData));
          localStorage.setItem('token', ret.data.token);
          localStorage.setItem('refreshToken', ret.data.refreshToken);
          pub('loginSuccess', userData);

          const { token: _omit, ...restQuery } = this.$route.query;
          this.$router.replace({ path: this.$route.path, query: restQuery });

          this.$nextTick(() => this.$router.push('/dashboard/index'));
        } else {
          pub('error_message', '免登失败，请手动输入账号密码');
        }
      } catch (e) {
        console.error('免登异常:', e);
        pub('error_message', '免登异常，请手动登录');
      }
    },

    login: async function () {
      if (this.submitting) return;
      if (!this.form.account || !this.form.password) {
        pub('error_message', '请输入账号和密码');
        return;
      }
      this.submitting = true;
      try {
        const ret = await this.$r.post(`login/login`, this.form);
        if (ret && ret.success) {
          this.$store.commit('config/setLeftBar', true);
          const userData = ret.data.user;
          localStorage.setItem('user', JSON.stringify(userData));
          localStorage.setItem('token', ret.data.token);
          localStorage.setItem('refreshToken', ret.data.refreshToken);
          pub('loginSuccess', userData);
          this.$nextTick(() => this.$router.push('/dashboard/index'));
        } else {
          pub('error_message', ret.message || '用户名密码错误');
        }
      } catch (e) {
        console.error('登录异常:', e);
        pub('error_message', e.message || '网络错误或服务器异常，请稍后重试');
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
/* ========== 桌面端默认（居中卡片） ========== */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #e8f0fe 0%, #d4e4f7 100%);
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

/* 桌面端卡片 */
.desktop-only {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 420px;
  max-width: 92%;
  padding: 40px 32px 32px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.10);
  text-align: center;
}

.brand {
  margin-bottom: 20px;
}
.brand-title {
  font-size: 28px;
  font-weight: 700;
  color: #1d8ee4;
  letter-spacing: 2px;
}
.brand-sub {
  font-size: 14px;
  color: #909399;
  margin-top: 4px;
}
.form-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 28px;
  color: #303133;
}

.login-form {
  width: 100%;
}
.login-form .el-form-item {
  margin-bottom: 18px;
}
.login-form .el-input__wrapper {
  border-radius: 8px;
  background: #f5f7fa;
  transition: 0.2s;
}
.login-form .el-input__wrapper:hover {
  background: #eef2f6;
}
.login-form .el-input__wrapper.is-focus {
  background: #fff;
  box-shadow: 0 0 0 2px rgba(29, 142, 228, 0.2);
}
.login-btn {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #1d8ee4, #1d70d8);
  border: none;
  letter-spacing: 2px;
}
.login-btn:hover {
  opacity: 0.9;
}

/* 移动端专属（原左右结构） */
.mobile-only {
  display: none; /* 桌面端隐藏 */
}

/* ========== 移动端适配（保留原有样式） ========== */
@media screen and (max-width: 768px) {
  .desktop-only {
    display: none !important; /* 桌面卡片隐藏 */
  }
  .mobile-only {
    display: flex !important; /* 显示移动端结构 */
  }

  .login-container {
    flex-direction: column;
    background: #f5f7fa;
  }

  .left-banner {
    width: 100%;
    height: 30vh;
    border-end-end-radius: 0;
    border-radius: 0 !important;
    padding: 30px 20px 20px;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: linear-gradient(to right, rgb(29,142,228), rgb(29,112,216));
    color: #e6f5ff;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  .brand-wrapper {
    margin-top: 0;
  }
  .brand-title {
    font-size: 26px;
    font-weight: bold;
  }
  .brand-sub {
    font-size: 13px;
    margin-top: 4px;
    color: #c1d9ff;
  }
  .brand-image {
    display: none;
  }

  .right-form {
    width: 100%;
    height: 70vh;
    background: #f5f7fa;
    align-items: flex-start;
    padding-top: 20px;
    display: flex;
    justify-content: center;
  }
  .form-wrapper {
    width: 88%;
    max-width: 400px;
    padding: 32px 20px;
    border-radius: 20px;
    background: white;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
    margin: 0 auto;
  }
  .form-title {
    font-size: 24px;
    margin-bottom: 24px;
    text-align: center;
    color: #303133;
  }
  .login-form .el-input__wrapper {
    background: #f0f2f5;
    border-radius: 8px;
    height: 44px;
  }
  .login-btn {
    height: 44px;
    font-size: 15px;
  }
}
</style>